export default "__VITE_ASSET__o2nHxG4t__"